import { useState } from 'react';

import { SearchableSelect } from '@/components/ui/searchable-select';

import {
  filterTransfereeOptions,
  type TransfereeCandidate,
} from './investorTransferUtils';

interface TransfereeSelectProps {
  id: string;
  candidates: TransfereeCandidate[];
  onSelect: (candidate: TransfereeCandidate) => void;
  selectedKey?: string;
  triggerLabel?: string;
  isLoading: boolean;
  disabled: boolean;
  placeholder: string;
}

export function TransfereeSelect({
  id,
  candidates,
  onSelect,
  selectedKey,
  triggerLabel,
  isLoading,
  disabled,
  placeholder,
}: TransfereeSelectProps) {
  const [search, setSearch] = useState('');

  return (
    <SearchableSelect
      id={id}
      options={filterTransfereeOptions(candidates, search)}
      getOptionKey={(candidate) => candidate.id}
      getOptionGroup={(candidate) =>
        candidate.isExistingFundInvestor ? 'In this fund' : 'Other investors'
      }
      renderOption={(candidate) => (
        <span className="truncate">{candidate.name}</span>
      )}
      onSelect={onSelect}
      onSearchChange={setSearch}
      debounceMs={0}
      selectedKey={selectedKey}
      triggerLabel={triggerLabel}
      isLoading={isLoading}
      disabled={disabled}
      placeholder={placeholder}
      searchPlaceholder="Search entities..."
      emptyMessage="No matching investor found."
      promptMessage="No eligible transferee investors"
    />
  );
}
